// extracted by mini-css-extract-plugin
export default {"products":"qs-z","card":"rs-z","oosMessaging":"ss-z"};